import { render, staticRenderFns } from "./Keyboard65Less.vue?vue&type=template&id=f2ce0224&scoped=true&"
import script from "./Keyboard65Less.vue?vue&type=script&lang=js&"
export * from "./Keyboard65Less.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard65Less.vue?vue&type=style&index=0&id=f2ce0224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ce0224",
  null
  
)

export default component.exports